import React, { useMemo } from "react";
import moment from "moment";
import FontAwesomeIcon from "../../Icon";

import './NextAppointment.scss';

export const NextAppointment = ({ nextAppointment }) => {
  const nextAppointmentDate = useMemo(() => {
    if(!nextAppointment) {
      return {
        date: "No Appointment",
        type: "none",
      };
    }
    const parsedJson = JSON.parse(nextAppointment);
    return {
      date: moment.utc(parsedJson.timeStamp).format("MM/DD/YYYY"),
      time: moment.utc(parsedJson.timeStamp).format("hh:mm A"),
      type: parsedJson.type,
    }
    
  }, [nextAppointment]);

  if (nextAppointmentDate.type === "none") return <></>

  return (
    <div className="next-appointment">
      <FontAwesomeIcon weight='solid' glyph={nextAppointmentDate.type === "walkthrough" ? "walking" : "wrench"} />
      <div>
      {nextAppointmentDate.date}
      </div>
      <div>
        {nextAppointmentDate.time}
      </div>
    </div>
  );
};
